export default "__VITE_ASSET__CM5hHkv4__"